import React, { useState, useRef, useEffect } from 'react';

export default function FilterDropdown({ currentFilter, onSelectFilter }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const options = [
        'All',
        'Today',
        'Next 7 days',
        'Next 14 days',
        'Next 28 days',
        'Previous Shifts',
        'Leaves'
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div style={styles.container} ref={dropdownRef}>
            <div 
                style={styles.trigger}
                onClick={() => setIsOpen(!isOpen)}
            >
                Filter ({currentFilter})
            </div>
            
            {isOpen && (
                <div style={styles.menu}>
                    {options.map((opt) => (
                        <div 
                            key={opt}
                            style={{
                                ...styles.option,
                                backgroundColor: currentFilter === opt ? '#f3f4f6' : 'transparent',
                                fontWeight: currentFilter === opt ? '600' : 'normal'
                            }}
                            onClick={() => {
                                onSelectFilter(opt);
                                setIsOpen(false);
                            }}
                        >
                            {opt}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

const styles = {
    container: {
        position: 'relative',
        display: 'inline-block'
    },
    trigger: {
        fontSize: '15px', color: '#374151', fontWeight: '600', cursor: 'pointer',
        padding: '8px 12px', borderBottom: '2px solid transparent',
        transition: 'color 0.2s'
    },
    menu: {
        position: 'absolute', top: '100%', right: 0, marginTop: '8px',
        backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
        width: '200px', zIndex: 50, border: '1px solid #f3f4f6', overflow: 'hidden'
    },
    option: {
        padding: '12px 16px', fontSize: '14px', color: '#4b5563', cursor: 'pointer', transition: 'background-color 0.2s'
    }
};
